import React from "react";
import Time from "../../time";
const PostDate = (props) => {
    const classNames = ((attributes) => {
        let className = ["wp-block-post-date"];
        if (attributes.align === "full") {
            className.push("alignfull");
        }
        if (attributes.textAlign) {
            className.push("has-text-align-" + attributes.textAlign);
        }
        if (attributes.className) {
            className.push(attributes.className);
        }
        return className.join(" ");
    })(props.attributes);
    if (props.children) {
        return React.createElement(Time, { date: props.children, className: classNames });
    }
    return React.createElement(React.Fragment, null);
};
PostDate._ges_name = "PostDate";
export default PostDate;
